'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var initialState = {
  navBar: {
    id: 'navBar-main',
    items: [{ to: '/', type: 'IndexLink', content: 'Generic Settings' }, { to: '/configuration', type: 'Link', content: 'Configuration' }, { to: '/template-application', type: 'Link', content: 'Template Application' }]
  }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/app.js
// module id = 1658
// module chunks = 0